import DrawingProgramsDialog from '../../components/DrawingPrograms';
import { Box } from "@mui/joy";
import { Outlet, useLocation } from "react-router";
import HeaderLK from "../../components/HeaderLK/HeaderLK";
import Sidebar from "../../components/Sidebar/Sidebar";

import { motion } from "framer-motion";
import { useEffect, useRef } from "react";
import SidebarDraftsman from "../../components/Sidebar/SidebarDraftsman";

import { useContext } from "react";
import { LayoutContext } from "../../context";
import { Sheet, Typography } from "@mui/joy";
import AccountBalanceWalletRoundedIcon from '@mui/icons-material/AccountBalanceWalletRounded';
import HourglassEmptyRoundedIcon from '@mui/icons-material/HourglassEmptyRounded';



function KonsolBanner() {
    const { account, setModalKonsolConnect } = useContext(LayoutContext);

    if (!account?.position?.includes('surveyor') && !account?.position?.includes('draftsman')) return null;
    if (account?.id_contractor_konsol) return null;

    const isPending = Boolean(account?.id_invite_konsol);

    return (
        <Sheet
            onClick={() => setModalKonsolConnect(true)}
            sx={{
                display: { xs: 'none', md: 'flex' },
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                px: 2,
                py: 0.9,
                cursor: 'pointer',
                bgcolor: isPending ? 'warning.300' : 'danger.500',
                color: isPending ? 'warning.800' : '#fff',
                transition: 'opacity .2s',
                '&:hover': { opacity: 0.9 },
                '&:active': { opacity: 0.8 },
                flexShrink: 0,
            }}
        >
            {isPending
                ? <HourglassEmptyRoundedIcon sx={{ fontSize: 16 }} />
                : <AccountBalanceWalletRoundedIcon sx={{ fontSize: 16 }} />
            }
            <Typography level="body-xs" fontWeight={600} sx={{ color: 'inherit' }}>
                {isPending
                    ? 'Документы на проверке — нажмите, чтобы подтвердить'
                    : 'Подключите Консоль.HRM для получения выплат'
                }
            </Typography>
        </Sheet>
    );
}


export default function LKPageDraftsman() {
    const location = useLocation();

    useEffect(() => {
      // Выполняется каждый раз, когда изменяется текущий путь
      console.log("Путь изменился на:", location.pathname);
  
      // Вы можете добавить дополнительные действия здесь
    }, [location]);

    const scrollContainerRef = useRef(null); // Референс на блок для прокрутки

    
    return (
        <Box sx={{ display: 'flex', height: '100dvh', overflow: 'hidden' }}>
            <DrawingProgramsDialog/>
            <SidebarDraftsman/>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    width: '100%',
                    minWidth: 0,
                }}
            >
                {/* Неподвижная полоса: баннер Консоли + шапка */}
                <KonsolBanner/>
                <HeaderLK/>

                {/* Прокручивается только контент */}
                <Box
                    ref={scrollContainerRef}
                    sx={{
                        flex: 1,
                        minHeight: 0,
                        overflow: 'auto',
                        width: '100%',
                    }}
                >
                    <Box
                        className="MainContent"
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            minWidth: 0,
                            gap: 1,
                        }}
                    >
                        <motion.main
                            initial={{ opacity: 0, y: 40 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 40 }}
                        >
                            <Outlet context={{ scrollContainerRef }}/>
                        </motion.main>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}